module.exports = __webpack_public_path__ + "img/revit.57c7f058.png";